export const validateKePassport = (idNumber) => {
    let passportRegex = /^[A-Z]{2}\d{7}$/;

    if (passportRegex.test(idNumber)) {
        return null;
    } else {
        return 'Enter a valid Kenyan Passport Number';
    }
};
